import { adminHttpClient } from '../../../../commons/adminHttpClient'
import { SavePerksProductClassRequest } from './productClass/savePerksProductClass'

export type ProductClassesRequest = {
  productClasses: SavePerksProductClassRequest[]
  planPeriodId: string
}

const completePerksEmployeeClasses = (productClasses: ProductClassesRequest): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/Perks/BenefitDesign/CompleteEmployeeClasses', productClasses)
}

export default completePerksEmployeeClasses
